import { fetchWrapper } from '@/_helpers';

export const miniSiteApi = {
    getMinisiteMapping: (teamId) => fetchWrapper.get(`teams/settings/${teamId}/minisitemappings`),
    updateMinisiteMapping: (teamId, data) => fetchWrapper.post(`teams/settings/${teamId}/minisitemappings`, data),
};
